<i18n>
{
  "fr": {
    "buttonLabel": "Payer et valider"
  }
}
</i18n>

<template>
  <button
    id="payment-button"
    type="submit"
    class="base-btn base-btn--secondary"
    :disabled="!hasSelection"
    @click="onClick"
  >
    {{ $t('buttonLabel') }}
    <i class="icon icon--arrow-right"></i>
  </button>
</template>

<script>
import CheckoutPayment from '../../mixins/CheckoutPayment';
import Loader from '../../mixins/Loader';

export default {
  name: 'PaymentButton',
  mixins: [CheckoutPayment, Loader],
  data() {
    return {
      hasSelection: false,
    };
  },
  mounted() {
    this.checkInputs();

    this.paymentForm.addEventListener('change', this.checkInputs);

    setTimeout(() => {
      this.checkInputs();
    }, 500);
  },
  beforeDestroy() {
    this.paymentForm.removeEventListener('change', this.checkInputs);
  },
  methods: {
    checkInputs() {
      this.hasSelection = Array.from(
        document.querySelectorAll('.checkout-input__input')
      ).some(element => element.checked);
    },
    onClick() {
      const form = document.getElementById('payment-form');
      const data = form ? JSON.parse(form.dataset.tracking || '{}') : {};
      const checkedInput = document.querySelector(
        '.checkout-input__input:checked'
      );
      if (checkedInput) {
        globalThis.dispatchEvent(
          new CustomEvent('lgf.initiateOrderPayment', {
            detail: {
              ecommerce: { ...data, payment_type: checkedInput.value },
            },
          })
        );
      }
      this.setLoader(this.reportFormValidity());
    },
  },
};
</script>
